export default __webpack_public_path__ + "static/media/bannermaspromoCS_30porcientoOff_330x330.fd684d72.webp";